module.exports = __webpack_public_path__ + "static/media/badge_level_6_3.bb130fb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_6_3.png
// module id = 518
// module chunks = 0